import BreadCrumb from 'src/_metronic/layout/components/breadcrumb'
import Form from '../component/New'

export default function TerminalNew() {
  return (
    <>
      <BreadCrumb currentPage='Create TPN' />
      <div id='kt_app_content_container' className='d-flex flex-column flex-root mt-10'>
        <Form />
      </div>
    </>
  )
}
